import { api_GET } from "api/axios.js";

const grupo_api =
{
    getAll: function () {
        const promise = new Promise((resolve, reject) => {
            api_GET(`grupo`).then(result => {
                resolve(result)
            });
        });

        return promise;
    }
}

export default grupo_api
